export const SearchIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Search</title>
      <g clipPath="url(#clip0_6671_3826)">
        <path
          d="M15.0367 14.9039L10.6367 10.5039"
          stroke="#636363"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M6.63516 12.1043C9.72795 12.1043 12.2352 9.59709 12.2352 6.5043C12.2352 3.4115 9.72795 0.904297 6.63516 0.904297C3.54236 0.904297 1.03516 3.4115 1.03516 6.5043C1.03516 9.59709 3.54236 12.1043 6.63516 12.1043Z"
          stroke="#636363"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_6671_3826">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
